import React, {useEffect}  from 'react';
import '../../css/aboutme.css';
import { Link } from 'react-router-dom';
import FAQ from './FAQ';
import { Helmet } from "react-helmet-async";

const AboutMe = () => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page on load
      }, []);

  return (
    <section id="aboutMe" className='no-padding margins'>
        <Helmet>
            <title>About Me | Meet Amna | Photos by Amna</title>
            <meta name="description" content="Learn more about Amna, the photographer behind Photos by Amna and discover her journey, passion, and approach." />
            <meta name="keywords" content="about Amna, photographer bio, toronto photographer, wedding photographer, photography journey" />
            <meta name="author" content="Photos by Amna" />
            <meta name="robots" content="index, follow" />

            {/* Open Graph */}
            <meta property="og:title" content="About Me | Meet Amna | Photos by Amna" />
            <meta property="og:description" content="Learn more about Amna, the photographer behind Photos by Amna and discover her journey, passion, and approach." />
            <meta property="og:image" content="https://www.photosbyamna.com/ogimage.jpg" />
            <meta property="og:url" content="https://photosbyamna.com/about" />
            <meta property="og:type" content="website" />
            <link rel="canonical" href="https://photosbyamna.com/about" />
        </Helmet>
        <h1>BEHIND THE LENS</h1>
        <div className='col-2 padding-4-side  padding-6-up'>
            <div>
            <img className='about-me-photo' alt="Photo of Amna - Toronto Photographer" src="./assets/profile-photo-crop.jpg" name="Toronto Photographer" loading='lazy'/>
            </div>
            <div>
                <h4 style={{fontWeight:"bold", marginTop:"0"}}>MEET AMNA</h4>
                <div className='horizontalSeperator'></div>
                {/* <p>I'm a home chef and make a mean salmon rice bowl, and while I'm not amazing at ping pong, I could play it all day just for fun. I love drawing, I go down rabbit holes when I'm editing, and I almost always have background TV playing. And even though I photograph people for a living, I’m actually pretty camera shy myself.</p> */}

                <p>My work blends artistic composition with candid moments, creating space for you to be yourself so your photos feel both true and timeless.
                Before I ever picked up a camera, I was telling stories through my drawings, coding games, and posting creative photos with very <em>deep</em> captions (we've all been there I think). Over time, photographing people became my passion. It lets me blend my visual instincts with genuine, heartfelt moments. Now, I live for the raw, unscripted stuff — a stolen glance, a spontaneous laugh. There's so much joy showing people a beautiful side of themselves in photos that they didn't even know was there. I can honestly say: I love what I do.
                    
                        
                    </p>
                    <p> When you choose me as your photographer, I’ll be with you every step of the way — from our first conversation to the moment you receive your gallery. Whether it’s a wedding, maternity session, or intimate couple shoot, my goal is to make the experience seamless and meaningful, so you can simply enjoy being present while I take care of the rest.
                    </p>

            </div>
        </div>
        {/* <h2>Follow my Jouney</h2> */}
        <div className='col-2  padding-6-side'>
            <div className='blog-post'>
                <Link to={`/portfolio`}>
                        <div className='blog-post-thumbnail'>
                        <img 
                            src='/assets/unscripted.avif' 
                            alt="through-my-lens"
                        />
                        </div>
                        <div className='blog-post-text'>
                        
                    <h3>Explore Portfolio</h3>
                    <p>Browse a crafted portfolio featuring weddings, couples, maternity, branding, and travel photography. Based in Toronto, telling stories worldwide.</p>
                    {/* <p className='blog-post-date'>{post.date}</p> */}
                    </div>
                </Link>
            </div>
        
            <div className='blog-post'>
                <Link to={`/blog/through-my-lens`}>
                        <div className='blog-post-thumbnail'>
                        <img 
                            src='/assets/blog/thumbnails/through-my-lens.avif' 
                            alt="through-my-lens"
                        />
                        </div>
                        <div className='blog-post-text'>
                        
                    <h3>Through My Lens: A Toronto Wedding Photographer’s Journey</h3>
                    <p>Discover how my passion for photography blossomed in the heart of Toronto, capturing love, life, and unforgettable moments.</p>
                    {/* <p className='blog-post-date'>{post.date}</p> */}
                    </div>
                </Link>
            </div>
            <div className='horizontalSeperator'></div>
        </div>

        
        <section className="no-padding no-margins">
            <br></br>
            <br></br>
        <FAQ/>
        </section>
        
    </section>
  );
};

export default AboutMe;
